import React, { Component } from 'react';
import './stylesheet/dropdown.less';
import handleTrackingDropdown from './actions/handleTrackingDropdown';

export default class TopMenuItem extends Component {
  handleClick = (event, value) => {
    event.stopPropagation();
    this.props.handleItemClicks(value);

    if (event.target.tagName.toLowerCase() === 'a') return;

    window?.dataLayer?.push?.({
      event: 'navigationClick',
      navigation: {
        type: 'topMenu',
        name: event?.target?.innerText || undefined,
        level: 0
      }
    });
  };

  returnItem = props => {
    return (
      <div id={`item-${props.index}`} className="subitems show">
        {props.subMenu
          .filter(item => item.online)
          .map(item => (
            <a
              key={item.base_item_id}
              href={`/${item.slug}`}
              onClick={event => {
                event.preventDefault();

                if (window.google_tag_manager) {
                  window?.dataLayer?.push?.({
                    event: 'navigationClick',
                    eventCallback: () => {
                      window.location.href = `/${item.slug}`;
                    },
                    eventTimeout: 500,
                    navigation: {
                      type: 'topMenu',
                      name: item?.title || undefined,
                      level: 1
                    }
                  });
                }

                window.location.href = `/${item.slug}`;
              }}
            >
              {item.title}
            </a>
          ))}
      </div>
    );
  };

  returnCustomItem = props => {
    return (
      <li role="presentation" className="item top-menu-items">
        <span className="nav-btn">
          <a
            className="customTopMenuItem"
            href={`/${props.slug}`}
            onClick={event => {
              event.preventDefault();

              if (window.google_tag_manager) {
                window?.dataLayer?.push?.({
                  event: 'navigationClick',
                  eventCallback: () => {
                    window.location.href = `/${props.slug}`;
                  },
                  eventTimeout: 500,
                  navigation: {
                    type: 'topMenu',
                    name: props?.title || undefined,
                    level: 1
                  }
                });
              }

              window.location.href = `/${props.slug}`;
            }}
          >
            {props.title}
          </a>
        </span>
      </li>
    );
  };

  render() {
    if (this.props.subMenu.length === 0)
      return this.returnCustomItem(this.props);
    return (
      <li
        role="presentation"
        className={
          this.props.isOpen
            ? 'item top-menu-items -selected'
            : 'item top-menu-items'
        }
        onClick={e => this.handleClick(e, this.props.index)}
      >
        <span
          className="nav-btn"
          data-cta={handleTrackingDropdown(this.props.id)}
        >
          {this.props.title}
        </span>
        {this.props.isOpen && this.returnItem(this.props)}
      </li>
    );
  }
}
